(function () {
  function getVisibleCount(grid) {
    var desktopCount = parseInt(grid.getAttribute('data-visible-count'), 10) || 18;
    var tabletCount = parseInt(grid.getAttribute('data-visible-count-tablet'), 10) || 9;
    var mobileCount = parseInt(grid.getAttribute('data-visible-count-mobile'), 10) || 6;

    if (window.innerWidth <= 749) return mobileCount;
    if (window.innerWidth <= 989) return tabletCount;
    return desktopCount;
  }

  function shuffleArray(items) {
    var copy = items.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function getCardsForCollection(root, key) {
    return Array.prototype.slice.call(
      root.querySelectorAll('[data-wall-card][data-collection-key="' + key + '"]')
    );
  }

  function getCollectionLink(root, key) {
    var link = root.querySelector('[data-collection-link="' + key + '"]');
    return link ? link.getAttribute('href') : '#';
  }

  function initWall(root) {
    if (!root || root.dataset.wallReady === 'true') return;

    var grid = root.querySelector('[data-wall-grid]');
    if (!grid) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wall-tab]'));
    var shuffleButton = root.querySelector('[data-wall-shuffle]');
    var shuffleMobileButton = root.querySelector('[data-wall-shuffle-mobile]');
    var shopButton = root.querySelector('[data-wall-shop]');
    var status = root.querySelector('[data-wall-status]');
    var visibleCount = getVisibleCount(grid);
    var activeKey = root.getAttribute('data-default-collection') || 'all';
    var currentIds = [];

    function setStatus(text) {
      if (status) status.textContent = text;
    }

    function updateShopButton(key) {
      if (!shopButton) return;
      shopButton.setAttribute('href', getCollectionLink(root, key));
    }

    function setActiveTab(key) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-wall-tab') === key);
        tab.setAttribute('aria-pressed', String(tab.getAttribute('data-wall-tab') === key));
      });
      activeKey = key;
      updateShopButton(key);
    }

    function renderSubset(cards, selected) {
      var ordered = shuffleArray(selected);

      cards.forEach(function (card) {
        card.classList.add('is-hidden');
        card.style.order = '';
      });

      ordered.forEach(function (card, index) {
        card.classList.remove('is-hidden');
        card.style.order = String(index + 1);
      });

      grid.classList.remove('is-all-visible');

      currentIds = ordered.map(function (card) {
        return card.getAttribute('data-product-id');
      });

      setStatus((root.getAttribute('data-status-showing') || '').replace('__visible__', ordered.length).replace('__total__', cards.length));
    }

    function getFreshSelection(cards) {
      var shuffled = shuffleArray(cards);
      var fresh = shuffled.filter(function (card) {
        return currentIds.indexOf(card.getAttribute('data-product-id')) === -1;
      });

      var selected = fresh.slice(0, visibleCount);

      if (selected.length < visibleCount) {
        var refill = shuffled.filter(function (card) {
          return selected.indexOf(card) === -1;
        });
        selected = selected.concat(refill.slice(0, visibleCount - selected.length));
      }

      return selected;
    }

    function activateCollection(key, forceRandomize) {
      var allCards = Array.prototype.slice.call(root.querySelectorAll('[data-wall-card]'));
      var cards = getCardsForCollection(root, key);

      allCards.forEach(function (card) {
        card.classList.add('is-hidden');
        card.style.order = '';
      });

      if (!cards.length) {
        setActiveTab(key);
        setStatus(root.getAttribute('data-status-empty') || '');
        return;
      }

      var selection;
      if (cards.length <= visibleCount) {
        // Wszystko sie miesci — pokazujemy w kolejnosci z kolekcji (reczna kuratorska).
        selection = cards.slice();
      } else if (forceRandomize) {
        // Klikniecie SHUFFLE albo przelaczenie zakladki — losujemy.
        selection = shuffleArray(cards).slice(0, visibleCount);
      } else {
        // Pierwsze wejscie na strone — poczatek kolekcji, czyli najlepsze prace na przodzie.
        selection = cards.slice(0, visibleCount);
      }

      setActiveTab(key);
      renderSubset(cards, selection);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateCollection(tab.getAttribute('data-wall-tab'), true);
      });
    });

    function handleShuffle() {
        var cards = getCardsForCollection(root, activeKey);

        if (cards.length <= visibleCount) {
          setStatus((root.getAttribute('data-status-complete') || '').replace('__total__', cards.length));
          return false;
        }

        renderSubset(cards, getFreshSelection(cards));
        return true;
    }

    if (shuffleButton) {
      shuffleButton.addEventListener('click', handleShuffle);
    }

    if (shuffleMobileButton) {
      shuffleMobileButton.addEventListener('click', handleShuffle);
    }

    window.addEventListener('resize', function () {
      var nextVisibleCount = getVisibleCount(grid);
      if (nextVisibleCount === visibleCount) return;
      visibleCount = nextVisibleCount;
      activateCollection(activeKey, false);
    });

    activateCollection(activeKey, false);
    root.dataset.wallReady = 'true';
  }

  function initAllWalls(scope) {
    (scope || document).querySelectorAll('[data-lw-wall]').forEach(initWall);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllWalls(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllWalls(event.target);
  });
})();
